import React from 'react';

import moment from "moment";

//import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';

import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import LoadingButton from 'components/Shared/LoadingButton';
import PdfLoadingButton from 'components/Shared/PdfLoadingButton';

import MyDatePicker from 'components/Shared/MyDatePicker';



const AdministrationPreparationLogistiquePhoto = () => {


    const [displayedDate, setDisplayedDate] = React.useState(moment().subtract(1, 'day').toDate().valueOf()); // Mettre la date d'hier par défaut.

    return (
        <>
            <Typography align="center" variant="h6" >Page de test AdministrationPreparationLogistiquePhoto</Typography>

            <hr />

            <Paper sx={{ margin: "8px" }}>

                {/*<DateCalendar value={displayedDate} onChange={(newValue) => setDisplayedDate(moment(newValue).toDate().valueOf())} />*/}

            </Paper>


        </>
    );
};


export default AdministrationPreparationLogistiquePhoto;